import { PaginationDuvidas } from 'api/Assessor/duvidas';
import {
  IAssembleiaAssessorAgenciaNucleosSemVoto,
  IAssembleiaAssessorLoadContas,
  IAssembleiasAssessorDocumentos,
  IAssembleiasAssessorEvent,
  IAssembleiasAssessorEventList,
  IAssembleiasAssessorPauta,
  IVotosInconsistentes,
} from './AssembleiasAssessorReducer';
import { IWSAssembleia } from './WSAssembleiasReducer';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA_TEMPO_DATA =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA_TEMPO_DATA';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_REPRESENTANTE =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_REPRESENTANTE';

export const ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE';
export const ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS';

export const ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO =
  'ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT =
  'ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT';

export const ASSEMBLEIAS_ASSESSOR_CLEARED_EVENTO =
  'ASSEMBLEIAS_ASSESSOR_CLEARED_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO =
  'ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOAD_EVENT_ATTACHMENT =
  'ASSEMBLEIAS_ASSESSOR_LOAD_EVENT_ATTACHMENT';
export const ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO =
  'ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO =
  'ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO';
export const ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS =
  'ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS =
  'ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS';
export const ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT =
  'ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT';

export const ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS =
  'ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS';
export const ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS_PRESENCIAL =
  'ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS_PRESENCIAL';
export const ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS =
  'ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS';
export const ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA =
  'ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA';
export const ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA =
  'ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS =
  'ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS';
export const ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS =
  'ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS';

export const ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA =
  'ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA';

export const ASSEMBLEIAS_ASSESSOR_REFRESH = 'ASSEMBLEIAS_ASSESSOR_REFRESH';

export const ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA =
  'ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA =
  'ASSEMBLEIAS_ASSESSOR_DELETAR_PAUTA';

export const ASSEMBLEIAS_ASSESSOR_LOAD_VOTOS_INCONSISTENTES =
  'ASSEMBLEIAS_ASSESSOR_LOAD_VOTOS_INCONSISTENTES';
export const ASSEMBLEIAS_ASSESSOR_LOADING_VOTOS_INCONSISTENTES =
  'ASSEMBLEIAS_ASSESSOR_LOADING_VOTOS_INCONSISTENTES';

export const ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_NUCLEOS_SEM_VOTO =
  'ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_NUCLEOS_SEM_VOTO';
export const ASSEMBLEIAS_ASSESSOR_LOADED_AGENCIAS_NUCLEOS_SEM_VOTO =
  'ASSEMBLEIAS_ASSESSOR_LOADED_AGENCIAS_NUCLEOS_SEM_VOTO';

export const ASSEMBLEIAS_ASSESSOR_EDITED = 'ASSEMBLEIAS_ASSESSOR_EDITED';

export const ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM =
  'ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM';

export const ASSEMBLEIAS_ASSESSOR_UPDATE_VOTATION =
  'ASSEMBLEIAS_ASSESSOR_UPDATE_VOTATION';

export interface IAssembleiaAssessorAlterarSituacaoPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA;
}

export interface IAssembleiaAssessorRequestFile {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE;
  payload: number[];
}

export interface IAssembleiaAssessorDownloadFileSuccess {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS;
  payload: number[];
}

export interface IAssembleiasAssessorLoadingEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO;
  payload: boolean;
}

export interface IAssembleiasAssessorLoadingEventAttachment {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT;
  payload: boolean;
}

export interface IAssembleiasAssessorClearedEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_CLEARED_EVENTO;
}

export interface IAssembleiasAssessorLoadEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO;
  payload: IAssembleiasAssessorEvent;
}

export interface IAssembleiasAssessorLoadEventAttachment {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_EVENT_ATTACHMENT;
  payload: IAssembleiasAssessorDocumentos[];
}

export interface IAssembleiasAssessorLoadingListaEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO;
  payload: boolean;
}

export interface IAssembleiasAssessorLoadListaEvento {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO;
  payload: IAssembleiasAssessorEventList[];
}

export interface IAssembleiasAssessorLoadingPautas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS;
  payload: boolean;
}

export interface IAssembleiasAssessorLoadingPautasPresencial {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS_PRESENCIAL;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadPautas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS;
  payload: IAssembleiasAssessorPauta[];
}

export interface IAssembleiasAssessorAlterandoStatusPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA;
  payload: boolean;
}

export interface IAssembleiasAssessorLoadingContas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS;
  payload: boolean;
}

export interface IAssembleiasAssessorLoadContas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS;
  payload: IAssembleiaAssessorLoadContas[];
}

export interface IAssembleiasAssessorLoadingDuvidas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS;
  payload: boolean;
}

export interface IAssembleiasAssessorLoadDuvidas {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS;
  payload: PaginationDuvidas;
}

export interface IAssembleiasAssessorRegistrandoPresenca {
  type: typeof ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA;
  payload: boolean;
}

export interface IAssembleiasAssessorDeleteCurrentEvent {
  type: typeof ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT;
  payload: undefined;
}

export interface IAssembleiasAssessorLoadingAgenciasPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA;
  payload: boolean;
}

export interface IAssembleiasAssessorRefresh {
  type: typeof ASSEMBLEIAS_ASSESSOR_REFRESH;
  payload: IWSAssembleia;
}

export interface IAssembleiasAssessorCadastrandoPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA;
  payload: boolean;
}

export interface IAssembleiaAssessorDeletandoPauta {
  type: typeof ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadVotosInconsistentes {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOAD_VOTOS_INCONSISTENTES;
  payload: IVotosInconsistentes[];
}

export interface IAssembleiaAssessorLoadingVotosInconsistentes {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_VOTOS_INCONSISTENTES;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadingAgenciasNucleosSemVoto {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_NUCLEOS_SEM_VOTO;
  payload: boolean;
}

export interface IAssembleiaAssessorLoadedAgenciasNucleosSemVoto {
  type: typeof ASSEMBLEIAS_ASSESSOR_LOADED_AGENCIAS_NUCLEOS_SEM_VOTO;
  payload: IAssembleiaAssessorAgenciaNucleosSemVoto[];
}

export interface IAssembleiaAssessorEdit {
  type: typeof ASSEMBLEIAS_ASSESSOR_EDITED;
  payload?: boolean;
}

export interface IAssembleiaAssessorUpdateQuorum {
  type: typeof ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM;
  payload: boolean;
}

export interface IAssembleiaAssessorUpdateVotation {
  type: typeof ASSEMBLEIAS_ASSESSOR_UPDATE_VOTATION;
  payload: boolean;
}

export type AssembleiasAssessorActionTypes =
  | IAssembleiaAssessorAlterarSituacaoPauta
  | IAssembleiaAssessorRequestFile
  | IAssembleiaAssessorDownloadFileSuccess
  | IAssembleiasAssessorLoadingEvento
  | IAssembleiasAssessorLoadingEventAttachment
  | IAssembleiasAssessorLoadEventAttachment
  | IAssembleiasAssessorClearedEvento
  | IAssembleiasAssessorLoadEvento
  | IAssembleiasAssessorLoadingListaEvento
  | IAssembleiasAssessorLoadListaEvento
  | IAssembleiasAssessorLoadingPautas
  | IAssembleiasAssessorLoadingPautasPresencial
  | IAssembleiaAssessorLoadPautas
  | IAssembleiasAssessorAlterandoStatusPauta
  | IAssembleiasAssessorLoadingContas
  | IAssembleiasAssessorLoadContas
  | IAssembleiasAssessorLoadingDuvidas
  | IAssembleiasAssessorLoadDuvidas
  | IAssembleiasAssessorRegistrandoPresenca
  | IAssembleiasAssessorDeleteCurrentEvent
  | IAssembleiasAssessorLoadingAgenciasPauta
  | IAssembleiasAssessorRefresh
  | IAssembleiasAssessorCadastrandoPauta
  | IAssembleiaAssessorDeletandoPauta
  | IAssembleiaAssessorLoadVotosInconsistentes
  | IAssembleiaAssessorLoadingVotosInconsistentes
  | IAssembleiaAssessorLoadingAgenciasNucleosSemVoto
  | IAssembleiaAssessorLoadedAgenciasNucleosSemVoto
  | IAssembleiaAssessorEdit
  | IAssembleiaAssessorUpdateQuorum
  | IAssembleiaAssessorUpdateVotation;
